export const cnTraditional = {
  About: '關於我們',
  // WhatWeDo: 'What We Do',
  LiveVideo: '錄影片段',
  // Solutions: 'Solutions',
  // Construction: 'Construction',
  // Retail: 'Retail',
  // HealthCare: 'Health Care',
  // EventVenues: 'Event Venues',
  // Transportation: 'Transportation',
  // Hospitality: 'Hospitality',
  // Platforms: 'Platforms',
  Client: '客戶',
  // HowItWorks: 'How it works',
  Team: '團隊',
  Media: '媒體',
  Awards: '成就',
  Apple: 'Apple',
  Contacts: '聯絡',
  News: '新聞',
  // SmartVenues: 'Smart Venues',
  // SmartConstruction: 'Smart Construction',

  // Cookie Consent
  CookieConsentMessage:
    'We use cookies to improve your browsing experience and help us improve our websites. We and carefully selected third parties also use cookies to show you more relevant ads online. By clicking "Accept All Cookies", you agree to our use of cookies in accordance with our Cookie Policy. If you wish to manage your cookie settings, please click "cookies information"',
  CookieAcceptAll: 'Accept All',
  CookieManage: 'Manage Cookies',
  CookieManagePreferences: 'Manage Cookie Preferences',
  CookieEssential: 'Essential Cookies',
  CookieEssentialDesc:
    'These cookies are necessary for the website to function and cannot be switched off.',
  CookieSavePreferences: 'Save Preferences',
  CookieShowDetails: 'Cookies Information',
  CookieHideDetails: 'Hide Details',
  CookieAnalytics: 'Analytics Cookies',
  CookieAnalyticsDesc:
    'These cookies help us understand how visitors interact with our website.',
  CookieMarketing: 'Marketing Cookies',
  CookieMarketingDesc:
    'These cookies are used to track visitors across websites for advertising purposes.',
  CookieAlwaysActive: 'Always Active',
  CookieConsentTitle: 'Cookie Consent Notification',
  CookiePreferencesSaved: 'Your cookie preferences have been saved.',
  CookieInformationHeader: 'Cookies Information',
  CookieInformationBody:
    'In order to enhance your experience across our platforms and show you more relevant information, we use cookies and smiliar technologies, both Sagadigits - owned. You may adjust your cookie and other privacy preferences below. For more information, see our Cookie Policy.',
  showPrivacy: 'Cookie Policy',
  PrivacyHeader: 'Privacy Policy',
  effectiveDate: 'Effective Date: 17th of June, 2025',
  updateDate: 'Last Updated: 17th of June, 2025',
  privacyPolicy:
    'This privacy policy explains how SagaDigits("we","us", or "our") collects, uses, and shares your personal information when you visit or interact with www.sagadigits.com (the "Website")',
  informationWeCollect: '1. Information We Collect',
  informationYouProvideToUs: `<strong>a. Information You Provide To Us:</strong>
    <ul style="margin-top: 0.5rem;">
      <li> - Name</li>
      <li> - Email address</li>
      <li> - Phone number</li>
      <li> - Any other information you submit through contact forms or service inquiries</li>
    </ul>`,
  informationWeCollectAutomatically: `<strong>b. Information We Collect Automatically:</strong>
    <ul style="margin-top: 0.5rem;">
      <li>- IP Address</li>
      <li>- Browser type and version</li>
      <li>- Device identifiers</li>
      <li>- Pages visited, links clicked, and browsing behavior</li>
      <li>- Cookies and similar tracking technologies (see section 6 below)</li>
    </ul>`,
  HowWeUseYourInformation: `<strong>2. How We Use Your Information</strong>
    <ul style="margin-top: 0.5rem;">
      <li>- Provide and improve our services</li>
      <li>- Communicate with you about updates or support</li>
      <li>- Analyze website usage and performance</li>
      <li>- Personalize content and advertising</li>
      <li>- Ensure legal compliance and protect against fraud</li>
    </ul>`,
  LegalBasis: `<strong>3. Legal Basis for Processing (EU Visitors)</strong>
    <ul style="margin-top: 0.5rem;">
      <li>- Consent</li>
      <li>- Contractual necessity</li>
      <li>- Compliance with legal obligations</li>
      <li>- Legitimate interests</li>
    </ul>`,
  SharingInfo: `<strong>4. Sharing Your Information</strong>
    <ul style="margin-top: 0.5rem;">
      <li>- Service Providers (e.g., web hosting, analytics, email delivery</li>
      <li>- Business Partners (only with your consent)</li>
      <li>- Government Authorities when legally required</li>
      <li>- Third parties in case of a business transfer, merger, or acquisition</li>
    </ul>`,
  YourRightsA: `<strong>a. If You Are in the EU/EEA (GDPR)</strong>
    <ul style="margin-top: 0.5rem;">
      <li>- Access your personal data</li>
      <li>- Correct inaccuracies</li>
      <li>- Delete your data ('Right to be forgotten')</li>
      <li>- Restrict or object to processing</li>
      <li>- Withdraw consent at any time</li>
      <li>- Lodge a complaint with a supervisory authority</li>
    </ul>`,
  YourRightsB: `<strong>b. If You Are in California (CCPA/CPRA)</strong>
    <ul style="margin-top: 0.5rem;">
      <li>- Know what personal information we collect and how we use it</li>
      <li>- Request deletion of your information</li>
      <li>- Opt out of the sale or sharing of your data</li>
      <li>- Non-discrimination for exercising your rights</li>
    </ul>
    <p>To exercise any of these rights, contact us at bd@sagadigits.com</p>`,
  CookiesAndTrackingTechnologies: `<strong>6. Cookies and Tracking Technologies</strong>
    <ul style="margin-top: 0.5rem;">
      <li>- Ensure website functionality</li>
      <li>- Analyze traffic and usage patterns</li>
      <li>- Personalize content and ads</li>
    </ul>
    <p>You can manage your preferences through our Cookie Settings modal.</p>`,
  DataRetention: `<strong>7. Data Retention</strong>
  <p>We retain personal information only for as long as necessary to fulfill the purposes outlined in this policy or as required by law.</p>`,
  DataSecurity: `<strong>8. Data Security</strong>
  <p>We implement reasonable technical and organizational measures to protect your personal information. However, no method of transmission over the internet is 100% secure.</p>`,
  InternationalDataTransfers: `<strong>9. International Data Transfers</strong>
  <p>If you are located outside of our hosting country, please be aware that your data may be transferred to, processed, and stored in countries with different privacy laws.</p>`,
  ChildrensPrivacy: `<strong>10. Children's Privacy</strong>
  <p>Our website is not intended for children under 13. We do not knowingly collect data from children.</p>`,
  ChangesToThisPolicy: `<strong>11. Changes to This Policy</strong>
  <p>We may update this Privacy Policy from time to time. We will post the updated version on this page with a revised 'Last Updated' date.</p>`,
  ContactUs: `<strong>12. Contact Us</strong>
  <p>If you have questions or requests regarding this policy, contact us at:</p>
  <p>Email: bd@sagadigits.com</p>
  <p>Address:  Unit 617, 12W Hong Kong Science Park, Shatin, New Territories, Hong Kong</p>
  <p>Website: www.sagadigits.com </p>`,

  // home
  'home-head-black-1': '給所有企業的',
  'home-head-red-1': '人工智能',
  'home-head-black-2': '與',
  'home-head-red-2': '大數據平台',
  'home-head-small':
    '隨賞科技有限公司提供市場領先的 AI 基礎架構，可實現數據即時性，幫助決策者快速作出決策。',
  'home-contact-btn': '聯絡我們',
  'section-title-1': '室內定位',
  'section-sub-title-1': '室內場域導航，掌握人員動向，人員安全防護',
  'section-1-img-1-title': '工廠端解決方案',
  'section-1-img-1-p':
    '掌握生產人員位置，有效控管人員區域密集度，進而減少場內能源消耗。人員呼叫快速定位，緊急事故發生能快速掌握人員位置，增加搶救黃金時間。',
  'section-1-img-2-title': '銷售',
  'section-1-img-2-p':
    '導引旅客航廈內部位置，快速解決多國旅客需求服務與登機閘門導引。快速協尋登機旅客位置，於App中主動通知旅客搭機服務，降低航班延飛等服務糾紛。',
  'section-1-img-3-title': '展館端解決方案',
  'section-1-img-3-p':
    '展品介紹服務，館內導引服務並能結合展品介紹服務，依據參觀者位置主動動態介紹展品服務。',
  'section-title-2': '我們的優勢',
  'section-2-row-1-title': '場域定位技術',
  'section-2-row-1-detail':
    'UWD室內精準定位系統：<br/>10cm~30cm高精密度定位距離，快速迅速定位。支援無限制擴充裝置數量。適用於長期建置，高穩定性。',
  'section-2-row-2-title': '裝置定位技術',
  'section-2-row-2-detail':
    '裝置定位方式採用兩種方式：<br/>手機定位結合專屬APP，適用於大型公共場域用戶。藍芽手環裝置定位，適用於工廠或醫院用戶',
  'section-2-row-3-title': '客製化功能系統',
  'section-2-row-3-detail':
    '配合場域需求搭配人員定位系統，客製功能需求。搭配旅客登機提醒功能，孩童距離提醒功能。人員呼救與周邊商家推廣...等等功能。',

  // solutions
  'solutions-head-h1': 'Comprehensive <br/> multimedia solution',
  'solutions-head-small':
    'From large TV walls to KIOSK multi-touch screens and the latest wave of somatosensory devices, according to different commercial marketing stages, we have developed corresponding application technologies to help customers create new-style business operation models and enhance brand market visibility, and Increase corporate profits and brand value.',
  'solutions-content-title':
    'Through comprehensive multimedia interaction Solutions become a communication platform between brands and consumers',
  'solutions-item-1-title': 'Construction',
  'solutions-item-1-detail': 'Interactive maps and wayfinding for smart office',
  'solutions-item-2-title': 'RETAIL',
  'solutions-item-2-detail':
    'Maps and wayfinding for shopping centers and retailers',
  'solutions-item-3-title': 'HEALTHCARE',
  'solutions-item-3-detail': 'Interactive maps and wayfinding for hospitals',
  'solutions-item-4-title': 'EVENT VENUES',
  'solutions-item-4-detail':
    'Event maps and wayfinding for trade shows, conventions and festivals.',
  'solutions-item-5-title': 'TRANSPORTATION',
  'solutions-item-5-detail':
    'Indoor maps and wayfinding for airports and train stations',
  'solutions-item-6-title': 'HOSPITALITY',
  'solutions-item-6-detail':
    'Maps and wayfinding solution for hotels, cruise lines and theme parks.',

  // platforms
  'platforms-head-h1':
    'Deploy new digital <br />services inside your <br />smart buildings',
  'platforms-head-small':
    'A simple hit on the “Publish” button will allow you to share your map with everyone!',
  'platforms-item-1-title': 'Wayfinding',
  'platforms-item-1-detail':
    'Mapwize has a Search Engine that allows users to locate any kind of resources on the map whether it is a meeting room or a printer.' +
    '<br /><br />' +
    'Mapwize provides a powerful Direction Engine to compute the best route towards your destination and can also optimize multi-destination itineraries. Reduced mobility users can select a dedicated mode to obtain suitable itineraries.',
  'platforms-item-2-title': 'CMS',
  'platforms-item-2-detail': `Mapwize uses outdoor global maps and adds indoor data to them. This way, our maps combine both indoor and outdoor services using the same tool.
    <br/><br/>
    All data not being of interest for everyone, Mapwize offers different Universes to display appropriate content in accordance with user roles (visitors, occupants, maintenance workers, security agents, etc.). Mapwize can manage an unlimited number of Universes per venue.
    <br/><br/>
    Mapwize has always been a multilingual platform with the ability to handle any language including Non-Europeans (Russian, Chinese, Arabic, etc.).`,
  'platforms-item-3-title': 'Dashboard',
  'platforms-item-3-detail': `Mapwize’s back-office, the Studio, is able to process the most common building file formats such as Autocad or GeoJSon. This way the overall floorplan import process is rapidly executed even by non-specialists.
    <br/><br/>
    Once existing floorplans are imported, the Studio provides all the necessary tools to add data and customize the maps. This includes but is not limited to: Universes, Points-of-Interest, Directions, Languages. Changes and updates are propagated in real-time on the platform.`,
  'platforms-item-4-title': 'Framework',
  'platforms-item-4-detail': `Mapwize works with any Indoor Positioning System (IPS) including but not limited to: Beacons, Wi-Fi, Li-Fi, Ultrasounds, Earth’s Magnetic field, Sensor fusion. Additionally, Mapwize provides a unique framework designed to combine multiple IPSs and select the most accurate system at anytime. Also, this framework enables advanced filters to increase position accuracy based on building topology.
    <br/><br/>
    This framework, called Indoor Positioning is available as an Open Source project under the MIT License.`,
  'platforms-item-5-title': 'Automation',
  'platforms-item-5-detail': `Mapwize is an open platform by design because we believe Indoor Mapping should be a core component to many third-party software applications. Accordingly, we also believe it is of the most importance to give developers a highly customizable mapping component.
    <br/><br/>
    Therefore, Mapwize comes with a fully interoperable Application Programming Interface (API) to permit server-side automation and multiple SDKs for iOS, Android and Javascript. This way, developers can easily embed Mapwize maps inside their own applications.
    <br/><br/>
    Mapwize API and SDKs are freely available on Github.`,
  'platforms-item-6-title': 'Security',
  'platforms-item-6-detail': `Security is a top concern here at Mapwize. Our maps are protected by strong access keys which are both customizable in scope (universes, floors, etc.) and duration.
    <br/><br/>
    Mapwize is hosted on the Microsoft Azure Cloud and is either available in SaaS mode (Multi-tenant server or private server) or on-premises.`,

  // how it works
  'howitworks-head-h1': 'How our service works',
  'howitworks-head-small':
    'A seamless path for buildings Indoor mapping just became easy. super easy to integrate and our customers would tell you the same! We are a developer-friendly company committed to providing the most complete tools for those who create the best mobile and web applications.',
  'howitworks-item-1-title': '整合服務',
  'howitworks-item-1-detail': '協助增建客戶需求功能。',
  'howitworks-item-2-title': '客製化可視化介面',
  'howitworks-item-2-detail':
    '客製化可視化介面，包含生產數據、機台運轉狀況、庫存資料呈現、客製化需求頁面。便利使用端快速了解生產資訊內容。',
  'howitworks-item-3-title': '數據收集',
  'howitworks-item-3-detail':
    '提供機台生產數據資料擷取功能。透過PLC資料擷取盒，獲取機台內部生產數據。解決無法取得機台生產資訊問題。',
  'howitworks-item-4-title': '依據機台數據進行分析',
  'howitworks-item-4-detail':
    '依據機台數據進行分析，透過AI自主學習技術進行問題建模，進而改善生產問題，提升生產效能。解決生產中問題狀況，有效提升生產效能與減少庫料耗損。',

  // imdf
  'imdf-head-h1': 'Apple Indoor <br/> Positioning Technology',
  'imdf-head-small': `Compathnion provides zero-additional hardware solution using Any WiFi based on Wherami technology. In iOS, we have cooperation with Apple ecosystem.
    <br/>
    Apple introduced indoor positioning technology for iOS on Any WiFi, which is accurate to about 3-5 metres. They have developed a new data model for positioning in iOS apps called IMDF.
    <br/>
    Compathnion is the 1st Large Scale Zero-Additional Hardware LBS Solution for both Android and iOS in the Greater Bay Area. And we have deployed the iOS solution in many venues.`,
  'imdf-item-1-title': '如何啟用iOS定位？',
  'imdf-item-1-detail': `我們擁有多年提供iOS定位服務的豐富經驗，屬於全港少數獲Apple認可的室內定位服務供應商。您可以跟隨以下步驟設定Apple室內導航服務：
    <br/><br/>
    <p>1. 於Apple Map Connect登記公司帳號及地址 (https://register.apple.com/indoor)</p>
    <p>2. 建立IMDF並上傳至Apple Map Connect</p>
    <p>3. 獲得許可後，進行實地測量</p>
    <p>4. 上傳實地數據</p>
    <br/><br/>
    我們提供一站式諮詢及安裝服務，為您完成IMDF設置、地圖實地繪製、App設計以及維護工作。`,
  'section-2-title': '為何要啟動iOS室內定位？',
  'imdf-horizontal-item-1-title': '完善的iOS支援',
  'imdf-horizontal-item-1-content': `室內和室外定位的無縫過渡。<br/>
    電池的優化使用：iOS 核心位置服務針對iOS設備進行了優化，並在定位和導航過程中將電池消耗降至最低。`,
  'imdf-horizontal-item-2-title': '強大的發展網絡',
  'imdf-horizontal-item-2-content': `作為場地擁有者，Apple 室內定位一旦在您的場地激活了，它就會給所有 iOS 平台應用程序開發員帶來好處。<br/>
    在應用程序方面，在 iOS 上啟用了任何室內定位，室內定位的覆蓋範圍就會持續擴大。`,
  'imdf-horizontal-item-3-title': '城市化 <br/> 定位服務',
  'imdf-horizontal-item-3-content':
    'Apple 室內定位旨在支持全市範圍內的應用程序。 該服務不限於單一場所，室內定位服務已在城市級別甚至跨城市進行了優化。',

  // Contact
  'contact-section-1-title': '聯絡我們',
  'contact-title': '隨賞科技有限公司',
  'contact-content-address': `
    香港新界沙田,
    <br />
    香港科學園,
    <br />
    12W, 6樓, 617室`,
  'contact-content-info': `
    電郵:  <br />
    <a href="mailto: info@compathnion.com">info@compathnion.com</a> <br />
    電話: <br />
    <a href="tel:+852-3465-5803">(852) 3465 5803</a><br/>
    網站: <br/>
    <a href="https://compathnion.com">https://compathnion.com</a>`,

  // Construction
  'construction-title': 'Construction',
  'construction-detail':
    'Customized visual interface, including production data, machine operating status, inventory data display and customized demand pages. Users can easily and quickly understand the content of production information.',
  'construction-item-1-title': '工業數位整合服務',
  'construction-item-1-detail': `
    工業4.0著重在將現有的工業相關的技術、銷售與產品體驗統合起來，是建立具有適應性、資源效率和人因工程學的智慧型工廠，我們將提供工廠數位化所需要的整合性技術服務。
    <br/><br/>
    MES：工廠生產履歷資訊建置協助服務
    <br/><br/>
    SCADA：環境監測與生產資訊可視化介面呈現應用服務
    <br/><br/>
    PLC：生產機台數據收集與自動化控制系統
    <br/><br/>
    AI深度學習技術：大數據深度分析與改善生產曲線服務系統。
  `,
  'construction-item-2-title': '整合服務架構',
  'construction-item-2-detail': `
    MES顧問管理，可視化建置服務，機台生產數據收集，AI深度學習技術
    <br/><br/>
    透過MES 系統架構，整合生產時所產生的數據資料，圖表化呈現顯示
    <br/><br/>
    透過我們的PLC資料擷取盒，主動獲取機台生產參數與數據資料，穩定傳送到MES資料庫中進行記錄。
    透過MES系統判斷彙整後，提供給予SCADA可視化介面進行數據資料呈現。
    <br/><br/>
    機台存取的數據資料，進入我們的AI深度學習技術，依據大數據分析後進而調整生產控制，有效提升生產效能。
  `,

  // Our Client
  'our-client-section-1-title': '合作客戶',

  // our team
  'our-team-title': '團隊',
  'our-teammate-2-name': '陳智銓先生',
  'our-teammate-2-position': '董事兼首席執行官',
  'our-teammate-2-description': `
  從大學時開始，他一直相信數據技術未來對每個人的影響會超過互聯網。
  <br /><br />
  他以一級榮譽生畢業於香港科技大學計算機科學工程專業，一直成績斐然，並且是加州大學洛杉磯分校的交換學者。
  <br /><br />
  他是物聯網、邊緣計算和開源軟件開發領域公認的專家。 他應邀在專業活動上發言，並擔任物聯網董事會成員。
  `,

  // news
  'news-section-title-1': '新聞',

  // Awards
  'awards-section-title-1': '我們的成就',

  // live video
  'live-video-head-h1': '模擬影片',
  'live-video-head-small': 'Top technology for the construction.',
  'live-video-section-title-1': '模擬影片',

  // footer
  'footer-title': '聯絡我們',
  'contact-email': '電郵: info@sagadigits.com',
  'contact-tel': '電話: (852) 3465 5803',
  'contact-address': '地址: 香港新界沙田, 香港科學園, 12W, 6樓, 617室',
  'footer-copyright': 'Compathnion, A Member of SagaDigits Group © 2023.'
}
